module.exports = __webpack_public_path__ + "weathericons-regular-webfont.8cac70ebda3f23ce4721.woff";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/weather-icons/fonts/weathericons-regular-webfont.woff
// module id = ../../../../../src/assets/scss/icons/weather-icons/fonts/weathericons-regular-webfont.woff
// module chunks = styles